/**
 * Updates the CSS variable for the venue image based on the provided venue ID.
 *
 * - Constructs the image path using the venue ID.
 * - Selects the `:root` element (the root of the document's CSS) and updates the `--venue-img` CSS variable with the new image URL.
 *
 * @param clubName - The club name to update the image for.
 */
export function updateVenueImage(clubName: string) {
  const venueImage = `../assets/club-images/${clubName}/venue.png`;
  const root = document.querySelector(':root');
  if (root) {
    // @ts-ignore
    root.style.setProperty('--venue-img', `url(${venueImage})`);
  }
}
